// Mock MSQ Case Studies data for testing purposes
export const mockMsqCaseStudies = [
  {
    id: 1,
    title: '<h2><strong>Manufacturing Excellence</strong> - Lean Implementation</h2>',
    status: 'active',
    description: '<p><strong>Case Study:</strong> Implementation of lean manufacturing principles in automotive industry.</p><ul><li>Process optimization</li><li>Waste reduction</li><li>Quality improvement</li></ul>',
    module_number: 'MODULE-2024-001-AUTO',
    video_url: '<p><strong>Case Study Video:</strong> <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ" target="_blank">Lean Manufacturing Implementation</a></p>',
    created_at: '2024-01-15T10:30:00Z',
    updated_at: '2024-03-20T14:45:00Z'
  },
  {
    id: 2,
    title: '<h3><em>Digital Transformation</em> in Healthcare</h3>',
    status: 'active',
    description: '<p><em>Case Study:</em> Digital transformation journey in healthcare sector focusing on:</p><ol><li><strong>Electronic Health Records</strong> implementation</li><li>Patient data security</li><li>Workflow optimization</li></ol>',
    module_number: 'MODULE-2024-002-HEALTH',
    video_url: '<h4>Healthcare Digital Transformation</h4><p><em>Video Series:</em> <a href="https://www.youtube.com/watch?v=9bZkp7q19f0" target="_blank">Digital Healthcare Implementation</a></p>',
    created_at: '2024-02-01T09:15:00Z',
    updated_at: '2024-03-18T16:20:00Z'
  },
  {
    id: 3,
    title: '<h4><u>Supply Chain Optimization</u> - Retail Sector</h4>',
    status: 'active',
    description: '<h3>Supply Chain Management Case Study</h3><p>Comprehensive supply chain optimization including:</p><ul><li>Inventory management systems</li><li>Supplier relationship management</li><li>Demand forecasting</li><li>Logistics optimization</li></ul>',
    module_number: 'MODULE-2024-003-RETAIL',
    video_url: '<div><h4><u>Supply Chain Videos</u></h4><ul><li><a href="https://vimeo.com/123456789" target="_blank">Supply Chain Optimization Strategies</a></li><li><strong>Duration:</strong> 60 minutes</li><li><em>Language:</em> English</li></ul></div>',
    created_at: '2024-01-20T11:00:00Z',
    updated_at: '2024-03-15T13:30:00Z'
  },
  {
    id: 4,
    title: 'Financial Services Innovation - Digital Banking',
    status: 'pending_review',
    description: 'Digital banking transformation case study',
    module_number: 'MODULE-2024-004-FINANCE',
    video_url: '<p><strong>Financial Innovation Training:</strong></p><ol><li><a href="https://www.youtube.com/watch?v=oHg5SJYRHA0" target="_blank">Digital Banking Fundamentals</a></li><li><em>Advanced Topics:</em> <a href="https://www.youtube.com/watch?v=example2" target="_blank">Fintech Integration</a></li></ol>',
    created_at: '2024-02-10T08:45:00Z',
    updated_at: '2024-03-19T10:15:00Z'
  },
  {
    id: 5,
    title: 'Education Technology Implementation',
    status: 'completed',
    description: 'EdTech implementation in higher education institutions',
    module_number: 'MODULE-2024-005-EDU',
    video_url: '<h3>Education Technology Case Study</h3><p><strong>Implementation Guide:</strong> <a href="https://www.youtube.com/watch?v=3JZ_D3ELwOQ" target="_blank">EdTech Integration Best Practices</a></p><p><em>Includes:</em> Student engagement, learning analytics, and digital assessment</p>',
    created_at: '2024-02-15T14:20:00Z',
    updated_at: '2024-03-21T09:45:00Z'
  },
  {
    id: 6,
    title: 'Sustainability Initiatives - Green Manufacturing',
    status: 'active',
    description: 'Green manufacturing and sustainability practices implementation',
    module_number: 'MODULE-2024-006-GREEN',
    video_url: 'https://www.youtube.com/watch?v=QH2-TGUlwu4',
    created_at: '2024-01-25T15:30:00Z',
    updated_at: '2024-03-17T11:20:00Z'
  },
  {
    id: 7,
    title: 'Customer Experience Transformation - E-commerce',
    status: 'active',
    description: 'Customer experience optimization in e-commerce platforms',
    module_number: 'MODULE-2024-007-ECOMMERCE',
    video_url: 'https://www.youtube.com/watch?v=YQHsXMglC9A',
    created_at: '2024-02-05T12:00:00Z',
    updated_at: '2024-03-10T14:00:00Z'
  },
  {
    id: 8,
    title: 'Data Analytics Implementation - Business Intelligence',
    status: 'active',
    description: 'Business intelligence and data analytics implementation case study',
    module_number: 'MODULE-2024-008-BI',
    video_url: 'https://www.youtube.com/watch?v=YQHsXMglC9A',
    created_at: '2024-01-30T16:45:00Z',
    updated_at: '2024-03-22T08:30:00Z'
  }
];

// MSQ Case Study statuses for filtering
export const msqCaseStudyStatuses = [
  { value: 'active', label: 'Active', color: 'bg-green-100 text-green-800' },
  { value: 'completed', label: 'Completed', color: 'bg-blue-100 text-blue-800' },
  { value: 'pending_review', label: 'Pending Review', color: 'bg-yellow-100 text-yellow-800' },
  { value: 'draft', label: 'Draft', color: 'bg-gray-100 text-gray-800' },
  { value: 'archived', label: 'Archived', color: 'bg-orange-100 text-orange-800' }
];

// Case study categories for reference
export const caseStudyCategories = [
  'Manufacturing',
  'Healthcare',
  'Financial Services',
  'Education',
  'Retail',
  'Technology',
  'Supply Chain',
  'Customer Experience',
  'Digital Transformation',
  'Sustainability'
];

// Industry sectors for reference
export const industrySectors = [
  'Automotive',
  'Healthcare',
  'Banking',
  'Education',
  'Retail',
  'Manufacturing',
  'Technology',
  'Government',
  'Non-profit',
  'Energy'
];
